export default __webpack_public_path__ + "static/Flamethrower_Ammo-ca108d802378bf4c8eb5ff67a54675ab.png";